// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3eWny","head":"Table_head__CVzgj","col":"Table_col__1kpSX"};